/**
 * Created by wyt on 2017/8/11.
 */
import RemoteCall from "../../util/RemoteCall";
const remoteCall = new RemoteCall("api/nursecarecore/dictionary");

function loadListAsync(str) {
    return remoteCall.invoke("loadList", ...arguments);
}

function getConfigAsync(str) {
    return remoteCall.invoke("getConfig", ...arguments);
}

function setConfigAsync(param) {
    return remoteCall.invoke("setConfig", param);
}

function getSysDictWithoutExceptionHandleAsync() {
    return remoteCall._invoke("getSysDict");
}

function findDictAsync(param) {
    return remoteCall.invoke("findDict", param);
}

function findDictsAsync(param) {
    return remoteCall.invoke("findDicts", param);
}

function addDictAsync(param) {
    return remoteCall.invoke("addDict", param);
}

function addDictsAsync(param) {
    return remoteCall.invoke("addDicts", param);
}

function deleteDictAsync(param) {
    return remoteCall.invoke("deleteDict", param);
}


export default {
    loadListAsync,
    getConfigAsync,
    setConfigAsync,
    getSysDictWithoutExceptionHandleAsync,

    findDictAsync,
    findDictsAsync,
    addDictAsync,
    addDictsAsync,
    deleteDictAsync,
}
